import React from 'react';
import {Grid, useMediaQuery, useTheme} from "@mui/material";
import './ContentContainer.sass'

function ProjectContentContainer({children}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div className={isMobile ? "content_container_mobile" : "content_container"}>
            <Grid container spacing={'2rem'}>
                <Grid item md={2} sx={{ display: { md: 'block', xs: 'none' } }} />
                <Grid item xs={12} md={8}>
                    {children}
                </Grid>
                <Grid item md={2} sx={{ display: { md: 'block', xs: 'none' } }} />
            </Grid>
        </div>
    );
}

export default ProjectContentContainer;